/**
 * Release switch for the module enable flags used by the Assessment/Audit navigation
 * (SidebarV2, BrandAudit/Form, CategoryAnalysis/Form, HomePageNew BrandAuditV2Module):
 * is_brandaudit_enabled, is_categoryanalysis_enabled, is_monitoring_enable,
 * is_conversation_enabled, is_contentmap_enabled, is_setting_enable, is_template_setting_enabled.
 *
 *  unset/false (dev)  - the dev user object has no such flags and dev always shows these items,
 *                 so only an explicit `false` hides them.
 *  "true" (prod)  - the flag must be truthy; null/undefined/false all hide, as the prod sidebar does.
 *
 * Set per environment with REACT_APP_STRICT_FLAGS in .env ("true" for prod, anything else/unset
 * = dev behavior). CRA bakes it in at build time, so restart `npm start` / rebuild after changing it.
 */
export const STRICT_FLAGS = process.env.REACT_APP_STRICT_FLAGS === "true";

export const isFlagOn = (value) => (STRICT_FLAGS ? !!value : value !== false);

/**
 * Per-user rollout switch for the new UI: grouped navbar (SidebarV2), merged "Assessment" tab in
 * Home Page - New, the Category radios in the Brand Audit / Category Analysis forms and the
 * "Assessment" wording. Comes from users.feature_flags.is_assessment_ui_enabled in the login response.
 */
export const isAssessmentUiOn = (user) => user?.feature_flags?.is_assessment_ui_enabled === true;
